module.exports = __webpack_public_path__ + "img/nadya.cfa89d9a.jpg";